import { Helmet } from 'react-helmet-async';
import { ListVuonTrongView } from 'src/sections/vuontrong/view';

// ----------------------------------------------------------------------

export default function VuongTrongListPage() {
  return (
    <>
      <Helmet>
        <title>Quản trị: Vườn trồng</title>
      </Helmet>
      <ListVuonTrongView />
    </>
  );
}
